"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadToSignedUrl = uploadToSignedUrl;
// XMLHttpRequest rather than fetch: only XHR reports upload progress.
function uploadToSignedUrl(args) {
    var url = args.url, headers = args.headers, file = args.file, onProgress = args.onProgress;
    var request = new XMLHttpRequest();
    var promise = new Promise(function (resolve, reject) {
        request.upload.onprogress = function (event) {
            if (event.lengthComputable) {
                onProgress(Math.round((event.loaded / event.total) * 100));
            }
        };
        request.onload = function () {
            if (request.status >= 200 && request.status < 300) {
                onProgress(100);
                resolve();
                return;
            }
            reject(new Error("Upload failed with status ".concat(request.status, ".")));
        };
        request.onerror = function () { return reject(new Error("Upload failed. Check your connection and try again.")); };
        request.onabort = function () { return reject(new Error("Upload cancelled.")); };
        request.open("PUT", url);
        Object.entries(headers).forEach(function (_a) {
            var name = _a[0], value = _a[1];
            return request.setRequestHeader(name, value);
        });
        request.send(file);
    });
    return { promise: promise, abort: function () { return request.abort(); } };
}
